import { ModalProviderContextType } from 'Portal/src/providers/ModalProvider/ModalProvider.types'

import { OrderSummaryErrorModal } from '../components/OrderSummary/OrderSummaryErrorModal'

export const showErrorModal = (
  onConfirm: () => void,
  setModal: ModalProviderContextType['setModal'],
) => {
  setModal({
    component: OrderSummaryErrorModal,
    isOpen: true,
    props: {
      onConfirm,
    },
  })
}
